import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Subject} from "rxjs";
import {OutletBlogPostService} from "../../../../service/api/outlet-blog-post.service";
import {finalize, takeUntil} from "rxjs/operators";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Component({
    selector: 'ol-blog-post-preview',
    templateUrl: './blog-post-preview.component.html',
    standalone: false
})
export class BlogPostPreviewComponent implements OnInit, OnChanges, OnDestroy {

    busy = false;             // indicator whether the component is busy
    initialized = false;      // indicator whether the component was initialized

    previewHtml = '';         // <-- holds the HTML we render into the iframe

    private readonly destroy$ = new Subject<void>();

    @Input() outletBlogPostDtoId: number;
    @Input() refreshSignal: number = 0;
    @Output() onBlogDeployment = new EventEmitter<void>();
    sanitizedHtml: SafeHtml;

    constructor(
        protected outletBlogPostService: OutletBlogPostService,
        private sanitizer: DomSanitizer
    ) {
    }

    ngOnInit(): void {
        this.initComponent();
    }

    /** Initialize Component. */
    initComponent() {
        this.refreshComponent();
    }

    /** Refresh Component. */
    refreshComponent() {
        this.getBlogPostPreview();
        this.initialized = true;
    }

    getBlogPostPreview() {
        if (!this.outletBlogPostDtoId || this.busy) {
            return;
        }

        this.busy = true;
        this.previewHtml = '';

        this.outletBlogPostService
            .getBlogPostPreview(this.outletBlogPostDtoId)
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => (this.busy = false))
            )
            .subscribe({
                next: (response: string) => {
                    this.previewHtml = response;
                    this.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(this.previewHtml);
                }
            });
    }

    /** Process changes within Binding. */
    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }

        // Fetch when the id changes
        if (changes['outletBlogPostDtoId'] || changes['refreshSignal']) {
            this.getBlogPostPreview();
        }
    }

    /** Destroy component. */
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
